import './PromoBlasterModal.pcss';
import React from 'react';
import { ModalBody, ModalFooter, ModalHeader } from '../modal-helpers';
import { ModalInstanceProps } from '../interfaces';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';

type Props = ModalInstanceProps & {
  publishCallback: () => any;
  cancelCallback: () => any;
};

const ConfirmModalBodyText = () => (
  <div>
    <div>
      Your Sponsored Message is now live. To check performance stats, please go
      to Ads Manager.
    </div>
    <br />
    <div>
      <a
        href="https://www.facebook.com/adsmanager"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://www.facebook.com/adsmanager
      </a>
    </div>
  </div>
);

export const PromoBlasterModal = (props: Props) => {
  const { publishCallback, closeModal, cancelCallback } = props;

  const onClickPublish = () => {
    publishCallback();
    closeModal();
  };

  const onClickClose = () => {
    cancelCallback();
    closeModal();
  };

  return (
    <div className="promo-blaster-modal">
      <ModalHeader
        closeOverride={onClickClose}
        className="promo-blaster-modal__header"
      >
        Sponsored Message is published!
      </ModalHeader>
      <ModalBody className="promo-blaster-modal__body">
        <ConfirmModalBodyText />
      </ModalBody>

      <ModalFooter className="promo-blaster-modal__footer">
        <Button onClick={onClickPublish}>Ok</Button>
      </ModalFooter>
    </div>
  );
};
